import { createFileRoute } from '@tanstack/react-router'

import { AuditPage } from '#/modules/system/audit-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/audit')({
  component: AuditPage,
  validateSearch: validateListSearch,
})
